// update state
const setDirectoryIdAction = (payload) => {
    return {
        type: "DIRECTORYID",
        payload
    }

}

export default setDirectoryIdAction;




// WEBPACK FOOTER //
// ./src/actions/setDirectoryIdAction.js